export default {
  returnTo(url) {
    // this.jtReturn(url)
    // this.pushHistore();
  },
  jtReturn(url) {
    window.addEventListener("popstate", function (e) {
      location.href = url;
    });
  },

  pushHistore() {
    var state = {
      title: "车务代办",
      url: ""
    };
    window.history.pushState(state, state.title, state.url);
  },
}



// WEBPACK FOOTER //
// ./src/assets/js/returnTo.js